var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.368 12.857h4.088m-2.044-2.286v4.572M17.566 14h.01m3.056-2.286h.01M12.915 6h3.17c2.683 0 4.024 0 5.077.568.927.501 1.698 1.303 2.21 2.301.582 1.134.678 2.63.869 5.623l.251 3.936c.124 1.93-1.244 3.572-2.974 3.572-.885 0-1.724-.44-2.29-1.2l-.384-.514c-.351-.47-.526-.706-.726-.896a2.936 2.936 0 0 0-1.467-.769c-.259-.05-.533-.05-1.08-.05H13.43c-.548 0-.822 0-1.08.05a2.936 2.936 0 0 0-1.468.769c-.2.19-.375.425-.726.896l-.383.514c-.567.76-1.406 1.2-2.29 1.2-1.731 0-3.099-1.642-2.975-3.572l.251-3.937c.191-2.992.287-4.488.869-5.622.513-.998 1.283-1.8 2.21-2.3C8.89 6 10.232 6 12.915 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.c28f87c9c0843153040d41a15d3f155e.svg";
export { ForwardRef as ReactComponent };